import { Route, Routes } from 'react-router';
import { LoginPage } from './public';
import { HomePage, PropertyPage } from './private';
import { PrivateRoute } from '../features/auth/components/PrivateRoute';
import { CoreLayout } from '../components/layout';

export const AppRoutes = () => (
  <Routes>
    <Route
      path="/"
      element={
        <PrivateRoute>
          <CoreLayout />
        </PrivateRoute>
      }
    >
      <Route index element={<HomePage />} />
      <Route path="property/:propertyId" element={<PropertyPage />} />
    </Route>
    <Route path="login" element={<LoginPage />} />
  </Routes>
);
